import { useState } from "react";
import { Send, Loader2 } from "lucide-react";
import { Input } from "../ui/input";
import { streamJoe } from "../../lib/api";

export const JoeChat = () => {
  const [msgs, setMsgs] = useState([{ role: "joe", text: "Hi, I'm Joe. Ask me anything about your situation — I'll explain things plainly and point you to the right professional when needed." }]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!input.trim() || busy) return;
    const text = input.trim();
    setInput("");
    setMsgs((m) => [...m, { role: "me", text }, { role: "joe", text: "" }]);
    setBusy(true);
    try {
      await streamJoe({ mode: "chat", message: text }, (t) => setMsgs((m) => [...m.slice(0, -1), { role: "joe", text: m[m.length - 1].text + t }]));
    } catch {
      setMsgs((m) => [...m.slice(0, -1), { role: "joe", text: "Sorry, I couldn't respond. Please try again." }]);
    }
    setBusy(false);
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid="joe-chat">
      <div className="max-h-[420px] space-y-3 overflow-y-auto pr-1">
        {msgs.map((m, i) => (
          <div key={i} className={`flex items-start gap-2 ${m.role === "me" ? "justify-end" : ""}`}>
            {m.role !== "me" && <img src="/brand/joe-avatar.webp" alt="Joe" className="h-9 w-9 shrink-0 rounded-full border-2 border-brand-navy object-cover" />}
          <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-[15px] leading-relaxed ${m.role === "me" ? "bg-slate-900 text-white" : "bg-amber-50 text-slate-800"}`} data-testid={`chat-msg-${i}`}>
            {m.text || <Loader2 className="h-4 w-4 animate-spin" />}
          </div>
          </div>
        ))}
      </div>
      <div className="mt-3 flex gap-2">
        <Input data-testid="joe-chat-input" value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Ask Joe a question…" className="h-12" />
        <button data-testid="joe-chat-send" onClick={send} disabled={busy} className="tap grid h-12 w-12 place-items-center rounded-xl bg-slate-900 text-white"><Send className="h-5 w-5" /></button>
      </div>
    </div>
  );
};
